import React from "react";
import { SectionBadge } from "./Comparison";
import { Zap, ShieldCheck, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const FEATURES = [
  {
    icon: <Zap className="h-6 w-6" strokeWidth={2.2} />,
    title: "Same-Day Decisions",
    body: "Submit in 3 minutes. Indicative offer within the hour. Drawn-down in as little as 24 hours on qualifying facilities.",
  },
  {
    icon: <ShieldCheck className="h-6 w-6" strokeWidth={2.2} />,
    title: "Whole-Of-Market Panel",
    body: "Working capital, asset, invoice, growth, commercial mortgages and bridging — all under one roof, all up to £500M.",
  },
  {
    icon: <Sparkles className="h-6 w-6" strokeWidth={2.2} />,
    title: "Structured Around You",
    body: "New-start, thin-file, adverse credit or complex — we structure the deal around your business, not against it.",
  },
];

export default function Features() {
  return (
    <section id="why" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-8">
            <SectionBadge>Why choose us</SectionBadge>
            <h2 className="font-display font-extrabold text-[40px] md:text-[56px] leading-[1.02] tracking-[-0.035em] text-navy mt-5">
              Business finance,<br />
              done <span className="text-emerald">properly.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Link to="/apply" data-testid="features-apply-btn" className="btn-shine group inline-flex items-center gap-2 h-12 px-6 rounded-xl bg-navy text-white font-bold text-[14px] hover:bg-navy-2 transition-colors">
              Get my quote <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2.4} />
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              data-testid={`feature-card-${i + 1}`}
              className="group relative rounded-[20px] bg-paper-warm border border-line p-7 md:p-8 hover:border-emerald/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="h-14 w-14 rounded-xl bg-emerald-soft text-emerald-3 flex items-center justify-center mb-6 group-hover:bg-emerald group-hover:text-white transition-colors">
                {f.icon}
              </div>
              <h3 className="font-display font-extrabold text-[22px] leading-[1.15] tracking-[-0.02em] text-navy mb-3">
                {f.title}
              </h3>
              <p className="text-[14.5px] leading-[1.6] text-navy/65 font-medium">{f.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
